'use client';

import React, { useEffect } from 'react';
import GlobalContext from './context';
import type { GlobalContextProviderProps, GlobalContextState } from './types';
import { rootReducer } from './reducers';
import { defaultState } from './reducers/constants';
import { setUser } from '@sentry/nextjs';
const GlobalContextProvider = ({
  children,
  initialValue = defaultState
}: GlobalContextProviderProps) => {
  const [state, dispatch] = React.useReducer(rootReducer, initialValue);
  useEffect(() => {
    setUser(initialValue?.user as any);
  }, [initialValue]);
  const contextValue: GlobalContextState = {
    state,
    dispatch
  };
  return <GlobalContext.Provider value={contextValue} data-sentry-element="unknown" data-sentry-component="GlobalContextProvider" data-sentry-source-file="provider.tsx">
      {children}
    </GlobalContext.Provider>;
};
export default GlobalContextProvider;